import { render, staticRenderFns } from "./DocumentInsertionSupport.vue?vue&type=template&id=3ba8367e&"
import script from "./DocumentInsertionSupport.vue?vue&type=script&lang=ts&"
export * from "./DocumentInsertionSupport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports